import React, { useState, useContext, useEffect } from 'react';
import { useSnackbar } from '../../context/SnackBarContext';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Button,
    Grid,
    Typography,
    Paper,
    List,
    ListItem,
    ListItemText,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import otgService from '../../services/otg.service';
import RegistrarCliente from './cliente/RegistrarClienteDet.component';
import RegistrarProducto from './producto/RegistrarProductoDet.component';
import { UserContext } from '../../context/UserContext';
import DialogEspere from '../../components/DialogEspere.component';

export default function RegistrarDeteriorado() {
    const datosSession = useContext(UserContext);
    const { showSnackbar } = useSnackbar();
    const history = useHistory();
    const datosRecibidos = useLocation();
const [variacionesSeleccionadas, setVariacionesSeleccionadas] = useState([]);

    // Estado para cliente seleccionado
    const [idCliente, setIdCliente] = useState('');
    // Estado para mostrar dialogo de espera (spinner)
    const [mostrarEspere, setMostrarEspere] = useState(false);
    // Estado para mostrar dialogo de éxito después de guardar OTGs
    const [mostrarDialogExito, setMostrarDialogExito] = useState(false);
    // Lista de OTGs a crear en lote
    const [listaOtg, setListaOtg] = useState([]);
    // IDs creados para luego enviarlos a ticket
    const [otgIdsCreados, setOtgIdsCreados] = useState([]);
    // Estado para datos de la OTG actual que se está creando (usa el cliente, la variante, etc)
    const [datosOtgActual, setDatosOtgActual] = useState({
        id_estado: 1,
        id_cliente: '',
        id_variacion: '',
        id_colaborador: datosSession.id_colaborador,
        ubi_origen: datosSession.id_ubicacion,
        recibido_por: datosSession.id_colaborador,
        id_canal: 1,
        ubi_destino: 19,
        responsable: 'Almacén Origen',
        fecha_compra: new Date().toISOString().split('T')[0],
        tipo_transporte: 'ida',
        envio_calidad: true,
        observaciones: '',
        servicios: [],
    });

    const handleClickSnackbar = (message, severity) => {
        showSnackbar({ message, severity });
    };
    
    const agregarOtgALista = () => {
            console.log('Servicios actuales:', datosOtgActual.servicios);

        if (!datosOtgActual.id_cliente || !datosOtgActual.id_variacion || !datosOtgActual.responsable?.trim()) {
            handleClickSnackbar('Completa los campos requeridos antes de agregar la OTG', 'warning');
            return;
        }
        
        setListaOtg([...listaOtg, datosOtgActual]);
        // Limpiar los campos menos el cliente para poder agregar otra OTG
        setDatosOtgActual((prev) => ({
            ...prev,
            id_variacion: '',
            observaciones: '',
            servicios: [],
            responsable: 'Almacén Origen',
            fecha_compra: new Date().toISOString().split('T')[0],
        }));
        handleClickSnackbar('OTG agregada a la lista', 'info');
    };

    const guardarDatos = async () => {
        const otgsAGuardar = [...listaOtg];
        const nuevosIds = [];

        setMostrarEspere(true);

        try {
            for (const otg of otgsAGuardar) {
                const response = await otgService.crearOtg(otg);
                nuevosIds.push(response.data.otgData.id_otg);
            }

            setOtgIdsCreados(nuevosIds);
            setMostrarDialogExito(true);
        } catch (err) {
            console.error('Error al guardar OTG:', err);
            handleClickSnackbar(`Error: ${err?.response?.data?.message || 'al crear una o más OTGs'}`, 'error');
        } finally {
            setMostrarEspere(false);
        }
    };

    useEffect(() => {
        try {
            if (datosRecibidos.state?.idCliente) {
                setIdCliente(datosRecibidos.state.idCliente);
            }
        } catch (error) {}
    }, [datosRecibidos]);

    useEffect(() => {
        setDatosOtgActual((prev) => ({ ...prev, id_cliente: idCliente }));
    }, [idCliente]);

    return (
        <>
            <DialogEspere open={mostrarEspere} />
            {!idCliente ? (
                <RegistrarCliente setIdCliente={setIdCliente} />
            ) : (
                <>
                    {/* RegistrarProducto recibe datosOtgActual y el setter para actualizar la OTG actual */}
                    <RegistrarProducto
                        datosOtg={datosOtgActual}
                        setDatosOtg={setDatosOtgActual}
                    />

                    {listaOtg.length > 0 && (
                        <Paper elevation={3} sx={{ mt: 4, p: 2 }}>
                            <Typography variant='h6'>OTGs en cola para guardar</Typography>
                            <List>
                                {listaOtg.map((otg, index) => (
                                    <React.Fragment key={index}>
                                        <ListItem>
                                            <ListItemText
                                                primary={`OTG #${index + 1}`}
                                                secondary={`Producto ID: ${otg.id_variacion} | Responsable: ${otg.responsable}`}
                                            />
                                        </ListItem>
                                        <Divider />
                                    </React.Fragment>
                                ))}
                            </List>
                        </Paper>
                    )}

                    <Grid container justifyContent='center' spacing={2} sx={{ mt: 2 }}>
                        <Grid item>
                            <Button
                                variant='outlined'
                                onClick={agregarOtgALista}
                                sx={{ color: 'text.primary' }}
                            >
                                Agregar OTG
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant='contained' onClick={guardarDatos}>
                                Guardar Todo
                            </Button>
                        </Grid>
                    </Grid>
                </>
            )}

            {/* Diálogo de Éxito */}
            <Dialog
                open={mostrarDialogExito}
                onClose={() => setMostrarDialogExito(false)}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { textAlign: 'center', py: 4 } }}
            >
                <DialogTitle sx={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    ¡Creado exitosamente!
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Las OTGs fueron creadas con éxito.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            setMostrarDialogExito(false);
                            history.push({
                                pathname: '/ticketdet',
                                state: {
                                    ids_otg: otgIdsCreados
                                }
                            });
                        }}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
